import React, { useState, useEffect } from 'react';
import { initiateCardBinding } from '../services/api';
import CreditCardForm from '../components/CreditCardForm';

const BindCardPage = () => {
    const [bindToken, setBindToken] = useState(null);
    const [transactionId, setTransactionId] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        // This flow follows the "User Bind Credit Card" sequence
        const fetchBindToken = async () => {
            try {
                // 1. Get bind card token from the backend
                const response = await initiateCardBinding();
                const { bindCardToken, transactionId: newTransactionId } = response.data.data; //
                
                if (!bindCardToken) {
                    throw new Error('Failed to retrieve bind token from the server.');
                }
                
                setBindToken(bindCardToken);
                setTransactionId(newTransactionId);

            } catch (err) {
                setError(err.response?.data?.message || err.message || 'Could not initiate card binding.');
            } finally {
                setLoading(false);
            }
        };

        fetchBindToken();
    }, []);

    if (loading) return <p>Initiating secure payment form...</p>;
    if (error) return <p className="error-message">{error}</p>;

    return (
        <div className="page-container">
            <CreditCardForm bindToken={bindToken} transactionId={transactionId} />
        </div>
    );
};

export default BindCardPage;